import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  myCountry: '',
  myYear: ''
}

const mutations = {
  changeYear(state, str){
      state.myYear = str;
  },
  changeCountry(state, str){
      state.myCountry = str;
  }
}

const store = new Vuex.Store({
  state: state,
  mutations: mutations
})

export default store




// WEBPACK FOOTER //
// ./src/store/index.js